import * as React from "react";
import * as ReactDOM from "react-dom";
import { PanelHeader } from "../react/panel-header.jsx";
import { EgenciaProvider } from "@egencia/uitk-react";

EG.HelpCenter.Presenters.PanelCallUs = function () {
    const panelViewName = "CallUs";
    const headerTitle = uitk.i18n.msg("contact_info_call_us");
    const headerContainer = ReactDOM.createRoot(document.getElementById("panel-header-container"));

    if (headerContainer) {
        headerContainer.render(
            <EgenciaProvider>
                <PanelHeader title={headerTitle} hasSearch={false} hasBackBtn={true} panelViewName={panelViewName}/>
            </EgenciaProvider>
        );
    }

    const $delegate = $('body'),
        phoneNumberClicked = 'HelpCenter.Panel.CallUs.Phone.Number.Clicked';

    $delegate.on('click', '.call-us-link', function () {
        omnitureLog.logClickEvent(phoneNumberClicked);
    });
    uitk.analytics.set('pageName', EG.pageName);
    uitk.analytics.send();
}; 